import React from 'react'

function BudgetNumber(num) {
    return <p>{new Intl.NumberFormat(['es-ES']).format(num)} €</p>
}

export default BudgetNumber
